import { Alignment, TextColor, TooltipType, TypographyMaxLines } from '../../../types';

export enum TypographyType {
  H1 = 'text-4xl font-semibold',
  H2 = 'text-[28px]/[36px] font-semibold',
  H3 = 'text-xl font-semibold',
  H4 = 'text-base font-semibold',
  BASE = 'text-base font-normal',
  SMALL = 'text-sm font-normal',
  BUTTON = 'text-sm font-normal tracking-[0.25px]',
  X_SMALL = 'text-xs font-normal',
  LABEL = 'text-xs font-semibold tracking-[0.5px] uppercase',
}

export interface TypographyProps {
  /** Content of the text. */
  children: React.ReactNode;
  /** Alignment of the text. */
  alignment?: Alignment;
  /** Additional class names to apply to the text. */
  className?: string;
  /** Color of the text. */
  color?: TextColor | string;
  /** Whether to use an italic font. */
  italic?: boolean;
  /** Maximum number of lines to display before truncating. */
  maxLines?: TypographyMaxLines;
  /** Whether to prevent the text from wrapping. */
  noWrap?: boolean;
  tooltip?: TooltipType;
  type?: TypographyType;
  underline?: boolean;
  /** Callback function to execute when the text is clicked. */
  onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

export type TypographyComponent = React.ReactElement<TypographyProps>;
